<template>
  <v-container>
    <h1 class="text-center text-uppercase">ONLINE PRODUCTS</h1>
    <v-row class="text-center">
      <v-col>
        <v-row>
          <v-col>
            <p class="overline">TOTAL PRODUCTS {{ ONLINE_PRODUCTS.length }}</p>
          </v-col>
          <v-col>
            <v-btn icon @click="getProducts">
              <v-icon>mdi-sync</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="ONLINE_PRODUCTS"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.mrp="{ item }">
        <p>{{item.mrp | rupee}}</p>
      </template>
      <template v-slot:item.rate="{ item }">
        <p>{{item.rate | rupee}}</p>
      </template>
      <template v-slot:item.stock="{ item }">
        <p>{{item.stock >= 1 ? item.stock : 'OUT OF STOCK'}}</p>
      </template>
      <template v-slot:item.image="{ item }">
        <template v-if="item.image == null">
          <v-img src="../../assets/Jet Wings alt.png" contain aspect-ratio="1.7" />
        </template>
        <template v-else>
          <v-img :src="item.image" contain aspect-ratio="1.7" />
        </template>
      </template>
      <template v-slot:item.id="{ item }">
        <v-icon color="error" class="mr-2" @click="editImage(item)">mdi-image-edit</v-icon>
        <v-icon color="warning" class="mr-2" @click="editItemPro(item)">mdi-pencil</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="editProd" persistent max-width="600px">
      <v-form ref="newForm">
        <v-card>
          <v-card-title>
            <span class="headline">EDIT PRODUCT</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-text-field
                  label="NAME"
                  required
                  v-model="editItems.name"
                  :rules="[RULES.required]"
                ></v-text-field>
                <v-autocomplete
                  v-model="editItems.cid"
                  :items="ONLINE_CATEGORY"
                  item-text="name"
                  item-value="id"
                  label="Category"
                  :rules="[RULES.required]"
                ></v-autocomplete>
                <v-text-field
                  label="Stock"
                  required
                  v-model="editItems.stock"
                  :rules="[RULES.required]"
                ></v-text-field>
                <v-text-field
                  label="MRP"
                  required
                  v-model="editItems.mrp"
                  :rules="[RULES.required]"
                ></v-text-field>
                <v-text-field
                  label="Rate"
                  required
                  v-model="editItems.rate"
                  :rules="[RULES.required]"
                ></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="error" block @click="editProd = false">Close</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary1" block dark @click="updateItems">UPDATE</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="imageupdload" persistent max-width="600px">
      <v-card>
        <v-card-title>IMAGE UPLOAD</v-card-title>
        <v-card-text>
          <div>
            <v-file-input
              label="Thumnail"
              show-size
              outlined
              accept="image/*"
              prepend-icon="mdi-camera"
              @change="onFileChange"
              v-model="image"
            ></v-file-input>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="imageupdload = false">Close</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary1" block dark @click="uploadImageServer">UPLOAD</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Product Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "MRP", value: "mrp" },
        { text: "Rate", value: "rate" },
        { text: "Category", sortable: true, value: "category" },
        { text: "Stock", sortable: true, value: "stock" },
        { text: "image", sortable: false, value: "image" },
        { text: "Action", value: "id" },
      ],
      editProd: false,
      editItems: {
        id: "",
        name: "",
        stock: "",
        category: "",
        mrp: "",
        rate: "",
        cid: "",
      },
      image: null,
      imageupdload: false,
      editImageId: "",
    };
  },
  created() {},
  computed: {
    ...mapGetters(["ONLINE_PRODUCTS", "RULES", "ONLINE_CATEGORY"]),
  },
  methods: {
    ...mapActions([
      "GET_ONLINE_PRODUCTS",
      "UPDATE_ONLINE_PRODUCTS",
      "UPLOAD_ONLINE_IMAGE",
    ]),
    getProducts() {
      this.$store.commit("SET_LOADING", true);
      this.GET_ONLINE_PRODUCTS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    editItemPro(item) {
      this.editItems = {
        id: item.id,
        name: item.name,
        category: item.category,
        mrp: item.mrp,
        rate: item.rate,
        stock: item.stock,
        cid: item.cid,
      };
      this.editProd = true;
    },
    updateItems() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.UPDATE_ONLINE_PRODUCTS(this.editItems).then(() => {
          this.editProd = false;
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    onFileChange(event) {
      this.image = event;
    },
    uploadImageServer() {
      if (this.editImageId != "" && this.image != null) {
        let formData = new FormData();
        formData.append("imagees", this.image);
        let data = JSON.stringify({ id: this.editImageId });
        formData.append("data", data);
        this.$store.commit("SET_LOADING", true);
        this.UPLOAD_ONLINE_IMAGE(formData).then(() => {
          this.editImageId = "";
          this.image = null;
          this.imageupdload = false;
          this.$store.commit("SET_LOADING", false);
        });
      } else {
        alert("Can Not Upload Image");
      }
    },
    editImage(item) {
      this.editImageId = item.id;
      this.image = null;
      this.imageupdload = true;
    },
  },
  watch: {},
};
</script>

<style></style>
